import {CompanyNewsTile, CompanyNewsTileType} from "@irati/types"

import {RowNames} from "../../types"

const COLS = 12

const tiles = {
  [RowNames.TWO_EQUAL]: [
    {ypos: 0, config: {type: CompanyNewsTileType.Empty, columnWidth: COLS / 2}},
    {ypos: 1, config: {type: CompanyNewsTileType.Empty, columnWidth: COLS / 2}}
  ],
  [RowNames.THREE_EQUAL]: [
    {ypos: 0, config: {type: CompanyNewsTileType.Empty, columnWidth: COLS / 3}},
    {ypos: 1, config: {type: CompanyNewsTileType.Empty, columnWidth: COLS / 3}},
    {ypos: 2, config: {type: CompanyNewsTileType.Empty, columnWidth: COLS / 3}}
  ],
  [RowNames.FOUR_EQUAL]: [
    {ypos: 0, config: {type: CompanyNewsTileType.Empty, columnWidth: COLS / 4}},
    {ypos: 1, config: {type: CompanyNewsTileType.Empty, columnWidth: COLS / 4}},
    {ypos: 2, config: {type: CompanyNewsTileType.Empty, columnWidth: COLS / 4}},
    {ypos: 3, config: {type: CompanyNewsTileType.Empty, columnWidth: COLS / 4}}
  ]
}

const getNewDefaultTiles = (rowName: RowNames, xpos: number): CompanyNewsTile[] => {
  const newTiles = tiles[rowName]
  if (!newTiles) {
    return []
  }

  // this errors because of the way the types are autogenerated
  // @ts-ignore
  return newTiles.map((tile) => Object.assign({}, tile, {xpos}))
}

export default getNewDefaultTiles
